import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Data, Router, NavigationEnd } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { TreoNavigationItem } from 'tsui/@treo';
import { Project, Property } from 'app/modules/projects/projects.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { ProjectTenantsService } from '../tenants.service';
import { ProjectAddAddressComponent } from 'app/modules/projects/modals/project-add-address/project-add-address.component';

@Component({
  selector: 'project-tenants-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectTenantsSidebarComponent extends OnDestroyMixin implements OnInit {
  menuData: TreoNavigationItem[] = [];
  project: Project;
  properties: Property[] = [];
  selectedProperty: Property;
  data: any;

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: Router,
    private readonly _matDialog: MatDialog,
    private readonly _projectsService: ProjectsService,
    private readonly _projectTenantsService: ProjectTenantsService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this._activatedRoute.data.pipe(untilComponentDestroyed(this)).subscribe((data: Data) => (this.data = data));

    this._projectsService.project$.pipe(untilComponentDestroyed(this)).subscribe((project: Project) => {
      if (project) {
        this.project = project;
        this.fillProperties();
      }
      this._changeDetectorRef.markForCheck();
    });

    this._projectTenantsService.property$.pipe(untilComponentDestroyed(this)).subscribe((property: Property) => {
      if (property) {
        this.selectedProperty = property;
      }
      this._changeDetectorRef.markForCheck();
    });

    this.checkRedirectToFirstPipeline(this._activatedRoute);

    this._router.events.pipe(untilComponentDestroyed(this)).subscribe((event) => {
      if (event instanceof NavigationEnd) this.checkRedirectToFirstPipeline(this._activatedRoute);
    });
  }

  onSelectionChange(event: MatSelectChange): void {
    this._router.navigate(['../', 'tenants', event.value.id], { relativeTo: this._activatedRoute });
  }

  checkRedirectToFirstPipeline(route: ActivatedRoute): void {
    if (!route.snapshot.firstChild && this.properties.length > 0) {
      this._router.navigate(['./', this.properties[0].id], { relativeTo: route });
    }
  }

  fillProperties() {
    if (this.project && this.project.properties && this.project.properties.length > 0) {
      this.properties = [...this.project.properties];
      this.configureMenu();
    }
  }

  openPropertyDialog(): void {
    this._matDialog
      .open(ProjectAddAddressComponent, {
        panelClass: 'mailbox-compose-dialog',
        data: { data: this.data },
      })
      .afterClosed()
      .pipe(untilComponentDestroyed(this))
      .subscribe(() => {
        this.fillProperties();
        this._changeDetectorRef.markForCheck();
      });
  }

  configureMenu(): void {
    let menuLinks = [];

    for (let property of this.properties) {
      menuLinks.push({
        title: property?.address?.address_string || 'Untitled',
        type: 'basic',
        icon: 'business',
        link: `../tenants/${property.id}`,
      });
    }

    this.menuData = [
      {
        title: 'Properties',
        type: 'group',
        children: menuLinks,
      },
      {
        title: 'Add Property',
        type: 'basic',
        icon: 'add_circle_outline',
        function: () => this.openPropertyDialog(),
      },
    ];
  }
}
